import { render, staticRenderFns } from "./MpaisForm.vue?vue&type=template&id=b7ac3960"
import script from "./MpaisForm.vue?vue&type=script&lang=js"
export * from "./MpaisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports